/**
 * MessageAttachment — the lightweight "file on a sent message" shape the chat
 * transcripts render (chips in the user bubble), built either from a live
 * upload response or from `ConversationDetail.attachments` on reload. Kept in a
 * `.ts` sibling so the `.tsx` component exports only the component.
 */
import type { ConversationAttachmentRead } from '../../services/agentConsole';

export interface MessageAttachment {
  id: string;
  filename: string;
  mimeType: string;
  sizeBytes: number;
}

export function toMessageAttachment(a: ConversationAttachmentRead): MessageAttachment {
  return {
    id: a.id,
    filename: a.filename,
    mimeType: a.mime_type,
    sizeBytes: a.size_bytes,
  };
}

/**
 * Group a detail's attachments by the user message they were claimed onto —
 * the turn mappers use this to stamp chips onto rebuilt user turns. Unclaimed
 * rows (message_id null — uploaded but never sent) are omitted.
 */
export function attachmentsByMessageId(
  attachments: ConversationAttachmentRead[] | undefined,
): Map<string, MessageAttachment[]> {
  const byId = new Map<string, MessageAttachment[]>();
  for (const a of attachments ?? []) {
    if (!a.message_id) continue;
    const list = byId.get(a.message_id) ?? [];
    list.push(toMessageAttachment(a));
    byId.set(a.message_id, list);
  }
  return byId;
}
